import { AgResourceLanguage } from '../types';
import { orderList as EnUsOrderList } from '../en-us/orderList';

export const orderList: AgResourceLanguage['orderList'] = {
  ...EnUsOrderList,
  filterOrders: {
    filterTitle: 'Afficher les commandes pour :',
    filterOptionTitle: 'Tous les abonnements'
  },
  emptyPastOrders: {
    title: `Vous n'avez encore aucune commande`,
    description: 'Commencez à faire vos achats et revenez plus tard sur cette page.',
    buttonName: 'Obtenez votre AG1'
  },
  emptyUpcomingOrders: {
    title: 'Vous n’avez pas de commandes à venir',
    buttonName: 'Obtenez votre AG1'
  },
  upcomingOrders: {
    title: 'Commandes à venir',
    card: {
      orderDateLabel: 'Date de commande',
      subscriptionNameLabel: 'Abonnement',
      subscriptionStatusLabel: 'Statut',
      unpaidStatus: 'Non payé',
      totalAmountLabel: 'Total',
      shipButton: 'Expédier maintenant',
      editDetailsButton: 'Modifier les détails',
      skipShipmentButton: 'Sauter l’expédition'
    }
  },
  pastOrders: {
    title: 'Commandes',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Numéro de commande',
      dateColumn: 'Date',
      subscriptionNameColumn: 'Abonnement',
      statusColumn: 'Statut',
      totalColumn: 'Total',
      trackButton: 'Suivre la commande',
      oneTimeLabel: 'Achat unique'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Commande',
      dateLabel: 'Date :',
      subscriptionLabel: 'Abonnement',
      statusLabel: 'Statut',
      totalLabel: 'Total',
      trackButtonMobile: 'Suivre la commande',
      trackButtonTablet: 'Suivre la commande',
      viewDetailsButton: 'Voir les détails'
    }
  }
};
